module.exports = __webpack_public_path__ + "files/6cf08f698e3fd94f7820460e7b06de6b.svg";